export const STORAYGE_KEY_MUTE = "AK_ACT_FES_SPRING_MUTE"
